<div class="tab-content">
  <div class="form-group" [formGroup]="form">
    @if (complianceManagementEnabled) {
    <!-- <div class="form-field" [class.missing-data]="isFieldMissing('regulatory_control')">
      <label for="controle_reglementaire">
        {{ "asset_form_drawer.compliance.regulatory_control" | translate }}
      </label>
      <nb-select
        id="regulatory_control"
        formControlName="regulatory_control"
        fullWidth
        placeholder="{{ 'asset_form_drawer.placeholders.select' | translate }}"
      >
        <nb-option value="">-</nb-option>
        <nb-option value="true">{{ "asset_form_drawer.options.yes" | translate }}</nb-option>
        <nb-option value="false">{{ "asset_form_drawer.options.no" | translate }}</nb-option>
      </nb-select>
    </div> -->

    <div class="form-field" [class.missing-data]="isFieldMissing('control_frequency')">
      <label for="frequence_controle">
        {{ "asset_form_drawer.compliance.control_frequency" | translate }}
      </label>
      <nb-select
        id="control_frequency"
        formControlName="control_frequency"
        fullWidth
        placeholder="{{ 'asset_form_drawer.placeholders.select_frequency' | translate }}"
      >
        <nb-option value="">-</nb-option>
        <nb-option value="1 time per year">{{ "asset_form_drawer.options.annual" | translate }}</nb-option>
        <nb-option value="1 time every 2 years">
          {{ "asset_form_drawer.options.once_every_2_years" | translate }}
        </nb-option>
        <nb-option value="1 time every 3 years">
          {{ "asset_form_drawer.options.once_every_3_years" | translate }}
        </nb-option>
        <nb-option value="1 time every 5 years">
          {{ "asset_form_drawer.options.once_every_5_years" | translate }}
        </nb-option>
        <nb-option value="1 time every 10 years">
          {{ "asset_form_drawer.options.once_every_10_years" | translate }}
        </nb-option>
        <nb-option value="other">{{ "asset_form_drawer.options.other" | translate }}</nb-option>
      </nb-select>
    </div>

    <div class="form-field pb-2 relative" [class.missing-data]="isFieldMissing('last_control_date')">
      <label for="date_dernier_controle">
        {{ "asset_form_drawer.compliance.last_control_date" | translate }}
      </label>
      <div class="report-field-row">
        <input
          nbInput
          id="last_control_date"
          class="field-value report-date-input"
          readonly
          [nbDatepicker]="regulatoryControlDate"
          [value]="formatDate(form.get('last_control_date')?.value)"
          placeholder="-"
          (click)="!regulatoryControlDate.isShown && regulatoryControlDate.show()"
        />
        <nb-datepicker
          #regulatoryControlDate
          [date]="toDateValue(form.get('last_control_date')?.value)"
          [visibleDate]="toDateValue(form.get('last_control_date')?.value)"
          (dateChange)="onDatepickerDateChange($event, 'last_control_date')"
        ></nb-datepicker>
        <span class="report-actions">
        @if (hasReport) {
        <i 
          class="fa-light fa-list-alt report-icon" 
          (click)="openControlReportDialog()">
        </i>
        }
        @if (!hasReport) {
        <i 
          class="fa-light fa-paperclip paperclip-icon" 
          (click)="openControlReportListDialog()">
        </i>
        }
        @if (!isColorWhite(getComplianceLastControlDateColor())) {
        <fa-icon
            [icon]="['fas', 'bell']"
            class="alert-icon">
        </fa-icon>
        }
        </span>
      </div>
    </div>
    }

    <!-- <div class="form-field">
      <label for="reserves_en_cours">{{ "asset_form_drawer.compliance.current_reserves" | translate }}</label>
      <div style="display: flex; align-items: center; gap: 8px; justify-content: space-between">
        <div style="width: fit-content">
          <input nbInput id="current_reserves" type="number" formControlName="current_reserves" readonly />
        </div>
        @if (!isColorWhite(getComplianceReservationsColor())) {
        <input
          type="color"
          [value]="getComplianceReservationsColor()"
          readonly
          disabled
          style="width: 12px; height: 12px; cursor: default; border: none; pointer-events: none; transform: translateX(-44px) translateY(-8px)"
        />
        }
      </div>
    </div> -->

    @if (complianceManagementEnabled) {
    <div class="form-field relative" [class.missing-data]="isFieldMissing('environmental_compliance')">
        <label for="conformite_environnementale">
          {{ "asset_form_drawer.compliance.environmental_compliance" | translate }}
        </label>
        <nb-select
          id="environmental_compliance"
          formControlName="environmental_compliance"
          fullWidth
          [placeholder]="'asset_form_drawer.placeholders.select' | translate"
        >
          <nb-option value="">-</nb-option>
          <nb-option value="true">{{ "asset_form_drawer.options.yes" | translate }}</nb-option>
          <nb-option value="false">{{ "asset_form_drawer.options.no" | translate }}</nb-option>
        </nb-select>
        @if (!isColorWhite(getComplianceEnvironmentalComplianceColor())) {
        <fa-icon 
          [icon]="['fas', 'bell']" 
          class="alert-icon" 
          style="position: absolute; top: 20px; right: 54px; cursor: default; border: none; pointer-events: none;">
        </fa-icon>
        }
    </div>
    }
    @if (complianceManagementEnabled) {
    @for (reserve of reserves; track $index) {
    <div class="reserve-header">
      <label style="color: #dc3545; font-weight: 600; flex: 1; text-align: center">
        {{ "asset_form_drawer.compliance.reserve_number" | translate: { number: $index + 1 } }}
      </label>
      <i 
        class="fa-light fa-list-alt report-icon" 
        (click)="openControlReportDialog()">
      </i>
    </div>

    <!-- Libellé réserve -->
    <div class="form-field">
      <label>{{ "asset_form_drawer.compliance.reserve_label" | translate }}</label>
      <div class="field-value">
        {{ reserve.libelle || '-' }}
      </div>
    </div>

    <!-- Stade -->
    <div class="form-field">
      <label>{{ "asset_form_drawer.compliance.reserve_status" | translate }}</label>
      <div class="field-value">
        @if (reserve.stade === 'active') {
          {{ "site_control_reports.status_active" | translate }}
        } @else if (reserve.stade === 'closed') {
          {{ "site_control_reports.status_closed" | translate }}
        } @else if (reserve.stade === 'abandoned') {
          {{ "site_control_reports.status_abandoned" | translate }}
        } @else if (reserve.stade) {
          {{ reserve.stade }}
        } @else {
          -
        }
      </div>
    </div>

    <!-- Date émission réserve -->
    <div class="form-field pb-2">
      <label>{{ "asset_form_drawer.compliance.reserve_emission_date" | translate }}</label>
      <div style="display: flex; align-items: center; gap: 8px; justify-content: flex-start;">
        <input
          nbInput
          class="field-value reserve-date-input"
          readonly
          [value]="formatDate(reserve.date_emission)"
          placeholder="-"
        />
      </div>
    </div>

    <!-- Criticité -->
    <div class="form-field">
      <label>{{ "asset_form_drawer.compliance.reserve_criticality" | translate }}</label>
      <div class="field-value">
        @if (reserve.criticite === 'critical') {
          {{ "asset_form_drawer.options.criticality_critical" | translate }}
        } @else if (reserve.criticite === 'non_critical') {
          {{ "asset_form_drawer.options.criticality_non_critical" | translate }}
        } @else {
          -
        }
      </div>
    </div>

    <!-- Responsable levée de réserve -->
    <div class="form-field">
      <label>{{ "asset_form_drawer.compliance.reserve_responsible" | translate }}</label>
      <div class="field-value">
        {{ reserve.responsable || '-' }}
      </div>
    </div>

    <!-- Date clôture -->
    <div class="form-field pb-2">
      <label>{{ "asset_form_drawer.compliance.reserve_closing_date" | translate }}</label>
      <div style="display: flex; align-items: center; gap: 8px; justify-content: flex-start;">
        <input
          nbInput
          class="field-value reserve-date-input"
          readonly
          [value]="formatDate(reserve.date_cloture)"
          placeholder="-"
        />
      </div>
    </div>
    }
    }
  </div>
</div>

<!--
<div class="add-reserve-section">
  <button type="button" class="add-reserve-button" (click)="addReserve()">
    <span class="red-text">(</span>
    <i class="fa-light fa-plus red-icon"></i>
    <span class="red-text">)</span>
    <span class="add-text">
      {{ "asset_form_drawer.compliance.add_reserve" | translate }}
    </span>
  </button>
</div>
-->
